export interface Artifact {
  id: string;
  artifactId: string;
  chatId: string;
  accountId: string;
  createdById: string;
  title: string;
  code: string;
  version: number;
  isShared: boolean;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
  toolResults?: Record<string, any[]>;
}

// Subset returned by public (unauthenticated) endpoint
export interface PublicArtifact {
  id: string;
  title: string;
  code: string;
  createdAt: string;
  toolResults?: Record<string, any[]>;
}

export type ArtifactCardVariant = 'shared' | 'my-artifacts';

// Generation status for artifacts being created
export type GeneratingArtifactStatus = 'generating' | 'complete' | 'failed';

// Artifact in the process of being generated (from template)
export interface GeneratingArtifact {
  id: string;
  templateId: string;
  templateTitle: string;
  status: GeneratingArtifactStatus;
  chatId?: string;
  artifactId?: string;
  error?: string;
}

// Sort options for artifact lists
export enum ArtifactSortOption {
  LastCreated = 'last_created',
  AToZ = 'a_to_z',
  ZToA = 'z_to_a',
}

export const artifactSortOptions = [
  { label: 'Last Created', value: ArtifactSortOption.LastCreated },
  { label: 'A - Z', value: ArtifactSortOption.AToZ },
  { label: 'Z - A', value: ArtifactSortOption.ZToA },
];
